import React from 'react';
import ReactDOM from 'react-dom';

class Toolbar extends React.Component {
	constructor(props) {
		super(props);
		
	}

	handleToolbarClick(val) {
		this.props.setCurrentTab(val);

	}


	render() {
		return (
			<div className="conversation-wrapper">

			<ul className="nav nav-tabs nav-tabs-solid" data-plugin="nav-tabs" role="tablist">
			    <li key='overview' className={`nav-item ${this.props.currentTab === false ? 'current':''}`} role="presentation">
			        <a onClick={() => this.handleToolbarClick(false)} className="nav-link"  data-toggle="tab" role="tab">
			            Overview
			        </a>
			    </li>

			    <li key={this.props.me.id} className={`nav-item ${this.props.currentTab == this.props.me.id ? 'current':''}`}  role="presentation">
			        <a onClick={() => this.handleToolbarClick(this.props.me.id)} className="nav-link" data-toggle="tab" role="tab">
			            <img style={{width:'20px',borderRadius:'50%'}} src={this.props.me.image} /> {this.props.me.firstname} (Me)
			        </a>
			    </li>

			    {this.props.users.map(user => {
			    	if(user.id == this.props.me.id) {
			    		return null;
			    	}
			    	return (
			    		<li key={user.id} className={`nav-item ${this.props.currentTab == user.id ? 'current':''}`}  role="presentation">
					        <a onClick={() => this.handleToolbarClick(user.id)} className="nav-link" data-toggle="tab" role="tab">
					            <img style={{width:'20px',borderRadius:'50%'}} src={user.image} /> {user.firstname}
					        </a>
					    </li>
			    	)
			    })}
			    
			    
			</ul>

				<div style={{position:'absolute',right:'10px',top:'16px'}}>
					{this.props.isOnline ? <span className="tag tag-success">You are online</span>:<span className="tag tag-danger">You are offline</span>}
				</div>

			</div>
		);
	}
}


export default Toolbar;



// WEBPACK FOOTER //
// ./components/chat/Toolbar.js